module.exports = __webpack_public_path__ + "static/media/particle-center.2fb8dd8e.svg";